import { render, staticRenderFns } from "./Basic-Details.vue?vue&type=template&id=6c169a57&scoped=true"
import script from "./Basic-Details.vue?vue&type=script&lang=js"
export * from "./Basic-Details.vue?vue&type=script&lang=js"
import style0 from "./Basic-Details.vue?vue&type=style&index=0&id=6c169a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c169a57",
  null
  
)

export default component.exports